const reviews = [
  {
    stars: 5,
    title: "Must have for golfers",
    body: "Essential for those that play any type of golf, endless amounts of formats. Great for societies and those that plan golf trips.",
    author: "Daveod17",
  },
  {
    stars: 5,
    title: "Great new app",
    body: "Just what is needed as an organiser of inter club matches and societies.",
    author: "123 Andy S",
  },
];

function StarIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-accent-500">
      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
    </svg>
  );
}

export default function Testimonials() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs uppercase tracking-[0.18em] text-secondary-700 font-semibold">What golfers are saying</span>
          <h2 className="mt-3 font-heading font-bold text-foreground-950 text-3xl md:text-4xl leading-tight">
            Rated 5.0 on the App Store
          </h2>
          <p className="mt-3 text-foreground-700 text-base leading-relaxed">
            Based on 4 App Store ratings.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
          {reviews.map((review) => (
            <article
              key={review.title}
              className="rounded-xl bg-background-50 border border-background-200 p-6 md:p-7"
            >
              <div className="flex items-center gap-1">
                {Array.from({ length: review.stars }).map((_, i) => (
                  <StarIcon key={i} />
                ))}
              </div>
              <h3 className="mt-4 font-heading font-semibold text-foreground-950 text-base">
                “{review.title}”
              </h3>
              <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
                {review.body}
              </p>
              <p className="mt-4 text-xs text-secondary-600 font-medium">
                — {review.author}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}